import {
  mapVenueRentalVersionDatesResponseType,
  useFindAllVenueRentalVersionsSuspense,
} from '@api';
import { VersionSelect } from '@common';
import { Route } from 'src/routes/_rootLayout/venues/$id.rental.$version';

export const VenueRentalVersionSelect: React.FC = () => {
  const { id, version: selectedVersion } = Route.useParams();

  const { data: versions } = useFindAllVenueRentalVersionsSuspense(id, {
    query: {
      select: (data) => mapVenueRentalVersionDatesResponseType(data),
    },
  });

  const previousVersion = versions[versions.indexOf(selectedVersion ?? '') - 1];
  const nextVersion = versions[versions.indexOf(selectedVersion ?? '') + 1];

  return (
    <>
      <VersionSelect selectedVersion={selectedVersion}>
        <VersionSelect.PreviousVersion
          to={Route.fullPath}
          params={{ id, version: previousVersion }}
          disabled={!previousVersion}
        />
        <VersionSelect.Combobox
          versions={versions}
          routePath={Route.fullPath}
          urlParams={{ id }}
        />
        <VersionSelect.NextVersion
          to={Route.fullPath}
          params={{ id, version: nextVersion }}
          disabled={!nextVersion}
        />
      </VersionSelect>
    </>
  );
};
